var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dlist"},_vm._l((_vm.Stage),function(event){return _c('mu-expansion-panel',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(event.title))]),_vm._v("\n        "+_vm._s(event.content)+"\n    ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }